import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { type IBanksResponse } from '../types/BanksTypes';
import { baseQuery, getBaseQueryWithReauth } from 'redux/baseQueryAuth';

export const BanksApi = createApi({
  reducerPath: 'Banks',
  tagTypes: ['Banks'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    getBanks: build.query<IBanksResponse, { payment_notification_type: string; status?: string; currency_code?: string; payment_method?: string }>({
      query: ({ payment_notification_type = '', status = '', currency_code, payment_method }) => ({
        params: { payment_notification_type, status, currency_code, payment_method },
        url: '/bank/',
        method: 'GET',
      }),
      providesTags: ['Banks'],
    }),
  }),
});

export const { useGetBanksQuery } = BanksApi;
